// extracted by mini-css-extract-plugin
export default {"player":"Header_player__Fl3+U","content":"Header_content__e8Iuw","animate":"Header_animate__NPlxQ","drawBorder":"Header_drawBorder__Jti-T","btn":"Header_btn__INAxa"};